import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './grid-operator.reducer';

export const GridOperatorDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const gridOperatorEntity = useAppSelector(state => state.gridOperator.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="gridOperatorDetailsHeading">
          <Translate contentKey="crawlerBackendApp.gridOperator.detail.title">GridOperator</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{gridOperatorEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="crawlerBackendApp.gridOperator.name">Name</Translate>
            </span>
          </dt>
          <dd>{gridOperatorEntity.name}</dd>
          <dt>
            <span id="ean">
              <Translate contentKey="crawlerBackendApp.gridOperator.ean">Ean</Translate>
            </span>
          </dt>
          <dd>{gridOperatorEntity.ean}</dd>
          <dt>
            <span id="fileNumber">
              <Translate contentKey="crawlerBackendApp.gridOperator.fileNumber">File Number</Translate>
            </span>
          </dt>
          <dd>{gridOperatorEntity.fileNumber}</dd>
        </dl>
        <Button tag={Link} to="/grid-operator" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/grid-operator/${gridOperatorEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GridOperatorDetail;
